// Leaflet (OpenStreetMap) for the attendance location screens — loaded the first time a map is shown,
// from /static/vendor/leaflet (no CDN). One copy per page: later calls get the same promise.
//
// Tiles come from tile.openstreetmap.org: an admin screen and an occasional check on the attendance
// page are well inside the OSM tile policy, and the attribution stays visible on every map.

const VENDOR = '/static/vendor/leaflet';
export const OSM_TILES = 'https://tile.openstreetmap.org/{z}/{x}/{y}.png';
export const OSM_ATTRIBUTION = '&copy; <a href="https://www.openstreetmap.org/copyright" target="_blank" rel="noopener">OpenStreetMap</a>';
// Seoul city hall — where a workplace without a point opens.
export const DEFAULT_CENTER = [37.5665, 126.978];

let loading = null;

export function loadLeaflet() {
    if (window.L && window.L.map) return Promise.resolve(window.L);
    if (loading) return loading;
    loading = new Promise((resolve, reject) => {
        if (!document.querySelector('link[data-leaflet-css]')) {
            const link = document.createElement('link');
            link.rel = 'stylesheet';
            link.href = `${VENDOR}/leaflet.css`;
            link.dataset.leafletCss = '';
            document.head.append(link);
        }
        const s = document.createElement('script');
        s.src = `${VENDOR}/leaflet.js`;
        s.async = true;
        s.onload = () => (window.L && window.L.map ? resolve(window.L) : reject(new Error('leaflet missing')));
        s.onerror = () => {
            loading = null;
            s.remove();
            reject(new Error('leaflet load failed'));
        };
        document.head.append(s);
    });
    return loading;
}

// pinIcon is the map marker: a CSS pin (attendance-geo.css .att-geo-pin), so Leaflet never looks for
// its default marker images.
export function pinIcon(L, extra) {
    return L.divIcon({
        className: 'att-geo-pin' + (extra ? ' ' + extra : ''),
        html: '<span></span>',
        iconSize: [28, 28],
        iconAnchor: [14, 28],
    });
}

// osmLayer adds the OSM tile layer with its attribution.
export function osmLayer(L) {
    return L.tileLayer(OSM_TILES, { maxZoom: 19, attribution: OSM_ATTRIBUTION });
}
